module.exports = __webpack_public_path__ + "static/media/web_marketing.903b0cd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/web_marketing.png
// module id = 500
// module chunks = 0